import React, { useId } from "react";
import "./AuthTextArea.css";

const AuthTextArea = ({ label, placeholder, required, Value, setValue }) => {
  const fieldId = useId();
  return (
    <div className="relative mb-4 w-full sm:w-[297px] maxTextAreaWidth font-quicksand">
      {label && (
        <label
          htmlFor={fieldId}
          className="absolute top-[-9px] left-3 w-fit max-w-[85%] truncate bg-card px-1 h-[16px] text-sm font-bold TextAreaLabel text-main rounded"
        >
          {label}
          {required && <span className="text-danger ml-0.5">*</span>}
        </label>
      )}
      <textarea
        id={fieldId}
        required={required}
        placeholder={placeholder}
        aria-label={label || placeholder}
        className="font-quicksand font-normal text-sm px-3 py-2 pr-3 border border-line bg-field text-ink placeholder:text-muted rounded-md w-full outline-none h-[95px] resize-y TextAreaText transition-colors duration-150 focus:border-main focus:ring-2 focus:ring-main/15"
        value={Value}
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  );
};

export default AuthTextArea;
